import { Component, OnInit } from '@angular/core';
import { Languages, FormMode, ServiceStatus } from 'src/app/shared/models/enums.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { User } from 'src/app/front-user/shared/models/user.model';
import { TransitAdminDto } from '../../shared/models/transit-admin.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { TransitAdminService } from '../../shared/services/transit-admin.service';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
import { TransitService } from 'src/app/front-user/services/e-booking/transit-request/transit-request.service';
import { first } from 'rxjs/operators';
import { TransitRequestDto } from 'src/app/front-user/services/e-booking/transit-request/transit-request.model';

@Component({
  selector: 'app-marine-mark-vessel-arrived',
  templateUrl: './marine-mark-vessel-arrived.component.html',
  styleUrls: ['./marine-mark-vessel-arrived.component.css']
})
export class MarineMarkVesselArrivedComponent implements OnInit {

  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  vesselArrivedForm: FormGroup;
  displayedLang: Languages;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO: BaseRequest //= new BaseRequest();
  submitted: boolean = false;
  user: User = new User();
  showRequest: boolean = false;
  adminDecisionObject: TransitAdminDto = new TransitAdminDto();
  numberRegex: string = '^[0-9]+(\\.?[0-9]+)?$';
  arrivalDateTimeDefault = new Date();
  responseObj: ResponseObject = new ResponseObject();

  transitData: TransitRequestDto = new TransitRequestDto();
  isErrorMessage: boolean = false;
  lockTaskErrorMessage: boolean = false;
  constructor(private formBuilder: FormBuilder, private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices, private route: ActivatedRoute, private router: Router,
    private translate: TranslateService, private adminSrv: TransitAdminService,
    private authenticationService: AuthenticationService, private alertService: AlertService, private transitSrv: TransitService) {

    this.displayedLang = this.globalSrv.getLanguage()
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    } else {
      window.history.back();
    }

    this.user = this.globalSrv.user;
    //this.baseRequestId = '47F8B6D4-7F34-4234-8377-35262235A57A';

  }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.vesselArrivedForm = this.formBuilder.group({
      IsArrived: ['', [Validators.requiredTrue]],
    ETA: ['', [Validators.required /*,CustomValidators.dateValidator()*/]],
      ArrivalDateTime: [''],
      ETATime: [new Date()],
      Requirements: ['', [Validators.required, CustomValidators.textSpaceValidator()]]
    });

  }
  getBaseRequest() {
    this.baseRequestService.getBaseRequest(this.baseRequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        this.requestStatus = this.baseRequestDTO.StatusId;
        if (this.requestStatus == ServiceStatus.PendingOnVesselArrival) {
          this.formMode = FormMode.Add;
          this.vesselArrivedForm.enable();
        }
        else if (history.state.data && history.state.data.isCompleted) {
          this.getTransitRequest();
        }
        else {
          this.getTransitRequest();
        }
      }
    )
  }

  get f() {
    return this.vesselArrivedForm.controls;
  }


  onSubmit(b) {

    this.submitted = true;
    // stop here if form is invalid
    if (this.vesselArrivedForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    if (this.vesselArrivedForm.get("ETA").value) {
      var selectedDate = this.vesselArrivedForm.get("ETA").value.toLocaleString('en-US', { year: "numeric", month: "numeric", day: "numeric" });
      var selectedTime = this.vesselArrivedForm.get("ETATime").value.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true })
      var fullDate = selectedDate + ", " + selectedTime;
      this.vesselArrivedForm.controls['ArrivalDateTime'].setValue(fullDate);

    }
    this.adminDecisionObject = this.vesselArrivedForm.value;
    this.adminDecisionObject.AdminEmail = this.user.UserName;
    this.adminDecisionObject.RequestId = this.baseRequestId;

    this.adminSrv.vesselArrived(this.adminDecisionObject)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.vesselArrivedForm.reset();
            this.showRequest = true;
            this.isErrorMessage = false;
          } else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            // this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]));
          }

        });
  }


  public getTransitRequest() {
    this.transitSrv.get(this.baseRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {

        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.transitData = resObj.Data;
          this.vesselArrivedForm.patchValue({
            IsArrived: true,
            ETA: this.transitData.ArrivalDateTime,
            ETATime: new Date(this.transitData.ArrivalDateTime),
            Requirements: this.transitData.Requirements
          });
          this.formMode = FormMode.Readonly;
          this.vesselArrivedForm.disable();
        }
      });
  }

}
